<template>
  <tr>
    <td class="d-flex justify-content-between" style="gap: 1rem">
      <div style="flex: 1">
        <el-checkbox
          v-if="waiting"
          :key="coach.id"
          :checked="coach.checked"
          @change="checkOrUncheckCoach($event, coach.id)"
        />

        <span v-if="coach.deviceToken" class="text-success"
          ><i class="icon-screen-smartphone"></i
        ></span>

        <el-popover
          v-if="coach.missingDocuments && coach.missingDocuments.length > 0"
          placement="top"
          title="Documents manquants"
          trigger="hover"
          :content="coach.missingDocuments.join(', ')"
        >
          <template #reference
            ><i class="fa fa-exclamation-triangle text-danger"></i
          ></template>
        </el-popover>

        {{ coach.name }}
        <el-popover
          style="margin-right: 10px"
          placement="top"
          trigger="hover"
          :width="230"
          :content="`Recruté depuis le ${formatDate(coach.existingSince)}`"
        >
          <template #reference><i class="fa fa-info-circle"></i></template>
        </el-popover>

        <a @click="goToUser"><i class="icon-user"></i></a>
        <span v-if="coach.disbursement" class="text-success ml-05"
          ><i class="fa fa-file"></i
        ></span>

        <el-popover
          v-if="coach.notes"
          placement="top"
          title="Note manager"
          trigger="hover"
          :width="400"
          :content="coach.notes"
        >
          <template #reference><i class="fa fa-pencil"></i></template>
        </el-popover>

        <br />
        <div class="stats" v-if="coach.rank">
          <StatIndicator
            label="TC"
            :value="coach.rank.conversion"
            :range="[0, 100]"
            unit="%"
          />

          <StatIndicator
            label="TF"
            :value="coach.rank.fidelisation"
            :range="[0, 100]"
            unit="%"
          />

          <StatIndicator
            label="NC"
            :value="coach.rank.rank"
            :range="[0, 5]"
            :decimals="2"
          />
        </div>

        <small
          v-if="coachStatusInfo"
          :style="`color: ${coachStatusInfo.color};`"
        >
          {{ coachStatusInfo.label }}
        </small>

        <br />

        <small v-if="coach.distance"
          >{{ coach.distance.distance }} {{ coach.distance.duration }}</small
        >

        <small v-else>Hors secteur {{ coach.distance }}</small>

        <br />

        <CoachStats :stats="coach.stats" :comments="coach.comments" />
      </div>

      <div class="text-right">
        <div v-if="accepted">
          <div v-if="coach.attributed">
            <span class="text-success">Attribué</span>
          </div>

          <div v-else>
            <span class="text-success mr-1">Accepté</span>

            <LoaderButton
              @ok="assign()"
              :loading="attribute"
              btn-class="btn-success"
              v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
            >
              <i class="icon-user-follow"></i> Attribuer

              <template v-if="credit">
                au tarif: {{ formatPrice(credit) }}
              </template>
            </LoaderButton>

            <button
              class="btn btn-sm btn-danger ml-05"
              @click="$emit('openRejectReasonModal')"
              v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
            >
              <i class="icon-close"></i> Refuser
            </button>
          </div>

          <small v-if="coach.respondedAt"
            >Accepté le: {{ formatDate(coach.respondedAt) }}</small
          >
        </div>

        <div v-else-if="rejected">
          <span class="text-danger">Refusé</span><br />
          <small v-if="coach.respondedAt"
            >Répondu le: {{ formatDate(coach.respondedAt) }}</small
          >
        </div>

        <div v-else-if="queued || waiting">
          <span class="text-primary">En attente de réponse</span>
          <button
            class="btn btn-sm btn-danger ml-05"
            @click="$emit('openRejectReasonModal')"
            v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
          >
            <i class="icon-close"></i>
          </button>

          <br />

          <small>Envoyé le: {{ formatDate(coach.assignedAt) }}</small>

          <br />

          <button
            class="btn btn-link btn-sm"
            @click="$emit('force')"
            v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
          >
            <small>
              <i class="icon-user-follow"></i>
              forcer l'attribution
              <template v-if="credit"
                >au tarif: {{ formatPrice(credit) }}</template
              >
            </small>
          </button>
        </div>

        <div v-else>
          <LoaderButton
            @ok="add()"
            :loading="attribute"
            btn-class="btn-secondary"
            v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
          >
            <i class="icon-plus"></i> Ajouter
            <template v-if="credit">
              au tarif : {{ formatPrice(credit) }}
            </template>
          </LoaderButton>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import StatIndicator from "@/components/coach/stats/indicator";
import LoaderButton from "@/components/form/LoaderButton";
import CoachStats from "@/components/coach/CoachStats";

export default {
  components: {
    StatIndicator,
    LoaderButton,
    CoachStats,
  },

  props: {
    coach: {
      type: Object,
      default: null,
    },
    queued: {
      type: Boolean,
      default: false,
    },
    accepted: {
      type: Boolean,
      default: false,
    },
    rejected: {
      type: Boolean,
      default: false,
    },
    waiting: {
      type: Boolean,
      default: false,
    },
    credit: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      adding: false,
      attribute: false,
    };
  },

  computed: {
    ...mapGetters({
      coachStatus: "getCoachStatus",
    }),

    coachStatusInfo() {
      if (this.coach?.status) {
        const status = this.coachStatus.find(
          (s) => s.value === this.coach.status,
        );

        return status;
      }

      return false;
    },
  },

  methods: {
    checkOrUncheckCoach(e, coachId) {
      this.$emit("addOrDeleteCoach", e, coachId);
    },

    goToUser(e) {
      e.preventDefault();

      const route = this.$router.resolve({
        name: "user-details",
        params: {
          id: this.coach.id,
        },
      });
      window.open(route.href, "_blank");
    },

    add() {
      this.adding = true;
      this.$emit("add");
    },

    assign() {
      this.attribute = true;
      this.$emit("assign");
    },

    displayComs(comments, type = "positive") {
      const predicates = {
        positive: (com) => com.type === 1,
        negative: (com) => com.type === -1,
        neutral: (com) => com.type === 0,
      };

      const comsToDisplay = comments.filter(
        predicates[type] || predicates.positive,
      );

      const strings = comsToDisplay.map(
        ({ label, text, author }, index) =>
          `${index + 1}. ${label} - ${text} (${author})`,
      );

      return strings.join(" ----- ");
    },
  },
};
</script>

<style scoped>
.stats .badge {
  font-size: 12px;
  margin: 0;
}

.fa-pencil {
  padding-left: 5px;
  color: #409eff;
}
</style>
